module.exports = "<app-company></app-company>"